import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { track } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import AuthModal from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import CourseDetail from "@/pages/CourseDetail";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import PayPalSuccess from "@/pages/PayPalSuccess";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Syllabus from "@/pages/Syllabus";
import Share from "@/pages/Share";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function Shell() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) localStorage.setItem("ko_ref", ref);
    if (!sessionStorage.getItem("ko_visit")) {
      sessionStorage.setItem("ko_visit", "1");
      track
        .visit({
          path: window.location.pathname,
          referrer: document.referrer || "",
          utm_source: params.get("utm_source") || "",
          utm_medium: params.get("utm_medium") || "",
          utm_campaign: params.get("utm_campaign") || "",
          ref: ref || "",
        })
        .catch(() => {});
    }
  }, []);

  const openAuth = (mode = "login") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <>
      <Header onOpenAuth={openAuth} />
      <Routes>
        <Route path="/" element={<Landing onOpenAuth={openAuth} />} />
        <Route path="/curso/:id" element={<CourseDetail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/paypal/success" element={<PayPalSuccess />} />
        <Route path="/checkout/subscription/success" element={<SubscriptionSuccess />} />
        <Route path="/temario" element={<Syllabus />} />
        <Route path="/compartir" element={<Share />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
      <Footer />
      <Chatbot />
      <AuthModal
        open={authOpen}
        mode={authMode}
        onClose={() => setAuthOpen(false)}
        onSwitch={(m) => setAuthMode(m)}
      />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
